module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/O0INa9/tc-custom/9781459209169.jpg?1717960366537",
      "alt": "This image is the cover for the book Dark Sicilian Secret"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Dark Sicilian Secret\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("A woman reveals to her baby daddy that she had his son in secret and he demands marriage in this international romance from a "), _c('i', [_vm._v("New York Times ")]), _vm._v("bestseller.")]), _c('br'), _c('br'), _vm._v("Lethally attractive Vittorio d’Severano was everything Jillian Smith wanted and their whirlwind romance was everything she dreamed it would be. Then she discovered his secret life and her dreams of a happily-ever—after crumbled into dust at the realisation that he’s her family’s greatest enemy . . . Brokenhearted, Jill disappeared."), _c('br'), _c('br'), _vm._v("Now Vitt has returned—to claim the tiny son Jill carried in secret and has sworn to protect! But to stay with her child, she must travel to Sicily and put Vitt’s ring on her finger. Yet what kind of marriage can they have when it’s based on secrets and a heat impossible to resist?"), _c('br'), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jane Porter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jane Porter loves central California's golden foothills and miles of farmland, rich with the sweet and heady fragrance of orange blossoms. Her parents fed her imagination by taking Jane to Europe for a year where she became passionate about Italy and those gorgeous Italian men! Jane never minds a rainy day – that's when she sits at her desk and writes stories about far-away places, fascinating people, and most important of all, love. Visit her website at: www.janeporter.com")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0